import { render, staticRenderFns } from "./newsletterN.vue?vue&type=template&id=2b5791d1"
import script from "./newsletterN.vue?vue&type=script&lang=js"
export * from "./newsletterN.vue?vue&type=script&lang=js"
import style0 from "./newsletterN.vue?vue&type=style&index=0&id=2b5791d1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports